// @dynamic-i18n-keys
// error.general.*
import type { FC } from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import { BiData, LoginErrorBiEvent } from '@wix/da-bi/pkg/events';
import { Url, sanitizeHref } from '@wix/da-url';
import s from './SisuPageError.scss';

export interface Props {
  errorTextKey?: string;
  errorType: string;
  rootPath: string;
  origin?: string;
  refreshApp: () => void;
  hardRefresh?: boolean;
  loginRefresh?: boolean;
}

const SisuPageError: FC<Props> = ({
  errorTextKey,
  errorType,
  rootPath,
  origin,
  refreshApp,
  hardRefresh,
  loginRefresh,
}) => {
  const { t } = useTranslation();
  const logBiEvent = useBiLogger();

  useEffect(() => {
    logBiEvent(
      BiData<LoginErrorBiEvent>({
        evid: 203,
        error_message: t([
          `${errorTextKey}.error.general.${errorType}`,
          `error.general.${errorType}`,
          'error.general',
        ]),
        error_type: errorType,
        user_name_challenge_mode: false,
      })
    );
  }, [errorType, t, errorTextKey, logBiEvent]);

  return (
    <div className={s['error-content']}>
      <img
        className={s['error-shroom']}
        src={Url.staticCDNLink('signinup/mushroom.png')}
        alt="Oh noes"
      />
      <div className={s['error-header']}>
        {t([
          `${errorTextKey}.error.general.${errorType}`,
          `error.general.${errorType}`,
          'error.general',
        ])}
      </div>
      <div className={s['error-detail']}>
        {t([
          `${errorTextKey}.error.general.${errorType}.detail`,
          `error.general.${errorType}.detail`,
          'error.general.detail',
        ])}
      </div>
      <a
        href={sanitizeHref(rootPath + origin)}
        className={s['error-refresh']}
        onClick={e => {
          e.preventDefault();
          if (loginRefresh) {
            window.location.assign('/users/login'); // TODO find better const
            return;
          }
          if (hardRefresh) {
            window.location.reload();
            return;
          }
          refreshApp();
        }}
      >
        {t('communitycard.refresh')}
      </a>
    </div>
  );
};
SisuPageError.displayName = 'SisuPageError';

export default SisuPageError;
